import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SimulatorStateType } from '../reducer/simulator.reducer'

const state = (state: RootState) => state.simulatorStore as SimulatorStateType

export const selectSimulatorDate = createDraftSafeSelector(state, (store) => store.timestamp)
export const selectSimulatorOrders = createDraftSafeSelector(state, (store) => store.orders)
export const selectSimulatorOrdersPrices = createDraftSafeSelector(state, (store) => store.ordersPrices)
export const selectSimulatorSecurityKey = createDraftSafeSelector(state, (store) => store.orderSecurityKey);
export const selectSimulatorOrderById = (orderId: string | undefined) => createDraftSafeSelector(state, (store) => {
    if(!orderId) return undefined
    const order = store.orders.find(o=>o.uuid===orderId)
    if(!order  || (order?.timeStamp??0)>store.timestamp) return undefined
    return order
})